const educationData = [
    {
      degree: "Bachelor's of Science",
      major: "Computer Engineering",
      institution: "University of Tennessee Knoxville",
      startDate: "Fall 2020",
      endDate: "Spring 2025",
      relevantCoursework: ['ECE455: Embedded Systems', 'CS489: Data Driven Security and Privacy', 'CS340: Software Engineering', 'CS360: Systems Programming', 'ECE351: Digital Logic Design']
    },
    {
        degree: "Bachelor's of Arts",
        major: "German Language and Literature",
        institution: "University of Tennessee Knoxville",
        startDate: "Fall 2020",
        endDate: "Spring 2025",
        relevantCoursework: ['Germ412: Advanced Language IV', 'Germ366: Multilingual Cultures in German Speaking World', 'Germ499: Berlin as a Cinematic City']
      },
  ];
  
  export default educationData;
  